/** @file Brush falloff: full strength inside hardness·radius, a smoothstep down to 0 at the radius. */
import { clamp } from '@pose2d/math/clamp';

/** Strength factor 0..1 at distance d from the centre of a brush of radius r (r ≤ 0 or d ≥ r → 0). */
export function brushFalloff(d: number, r: number, hardness: number): number {
  if (!(r > 0) || !(d < r)) return 0;
  const h = clamp(hardness, 0, 1);
  const t = d / r;
  if (t <= h) return 1;
  const u = (t - h) / (1 - h);
  return 1 - u * u * (3 - 2 * u);
}
